import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { CGradientButton } from "../../componets/button/gradient";
import CTypography from "../../componets/typography";
import { TERMS_LAST_UPDATED, TERMS_SECTIONS } from "./data";
import {
	ItemBodyGrey,
	ItemContainer,
	ItemTitle,
	ItemTitlePrefix,
	MainTitle,
	PrivacyStyled,
	TitleWrapper,
} from "./terms-styled";

export const TermsConditions = () => {
	const { pathname } = useLocation();

	useLayoutEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, [pathname]);

	return (
		<PrivacyStyled>
			<TitleWrapper>
				<CGradientButton className="terms-badge">
					<CTypography
						color="var(--Blue)"
						weight="bold"
						className="terms-button-text"
					>
						Legal terms
					</CTypography>
				</CGradientButton>
				<MainTitle color="var(--Black)" weight="bold" className="black-title">
					CorePass: Terms &amp; Conditions (Terms of Service)
				</MainTitle>
				<ItemBodyGrey>Last updated: {TERMS_LAST_UPDATED}</ItemBodyGrey>
			</TitleWrapper>

			{TERMS_SECTIONS.map((section) => (
				<ItemContainer key={section.number}>
					<ItemTitle>
						<ItemTitlePrefix>{section.number}.</ItemTitlePrefix>
						{section.title}
					</ItemTitle>
					{section.paragraphs.map((paragraph, index) => (
						<ItemBodyGrey key={`${section.number}-${index}`}>
							{paragraph}
						</ItemBodyGrey>
					))}
				</ItemContainer>
			))}
		</PrivacyStyled>
	);
};
